import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../Form/FormField";
import FormDate from "../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {withStyles} from "@material-ui/core";
import {getPersonName, mergeWithDefault} from "../Form/utils";
import FormCheck from "../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../Form/DeleteButton";
import FormSelect from "../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../Media/DropButton';
import InputAdornment from '@material-ui/core/InputAdornment';

class CooperationsFormFields extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
        };
    }

    render() {
        const {
            values,
            touched,
            errors,
            board,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            isEdit,
            setFormikState,
        } = this.props;

        return (
            <form
                method="POST"
                url={formUrl}
                onSubmit={handleSubmit}
            >

                <input type="hidden" name="board_id" value={values.board_id} onChange={handleChange}/>

                <Grid container spacing={24}>
                    <Grid item xs={12} sm={6}>
                        <FormField
                            type="text"
                            disabled
                            autoComplete={false}
                            name="board_name"
                            label={i18n.get('cooperations.board_name')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={board.board_name}
                        />
                    </Grid>
                    <Grid item xs={0} sm={1}></Grid>
                    <Grid item xs={12} sm={3}>
                        <FormField
                            type="text"
                            name="payment"
                            label={i18n.get('cooperations.payment')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.payment}
                        />
                    </Grid>
                    <Grid item xs={0} sm={2}></Grid>
                    <Grid item xs={4} sm={2}>
                        <FormDate
                            type="date"
                            name="day_contract_start"
                            label={i18n.get('cooperations.day_contract_start')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.day_contract_start}
                            error={errors.day_contract_start}
                            touched={touched.day_contract_start}
                        />
                    </Grid>
                    <Grid item xs={4} sm={2}>
                        <FormDate
                            type="date"
                            name="day_contract_end"
                            label={i18n.get('cooperations.day_contract_end')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.day_contract_end}
                            error={errors.day_contract_end}
                            touched={touched.day_contract_end}
                        />
                    </Grid>
                    <Grid item xs={6} sm={2}>
                        <FormDate
                            type="text"
                            name="day_contract"
                            label={i18n.get('cooperations.technician')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.day_contract}
                            error={errors.day_contract}
                            touched={touched.day_contract}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                </Grid>

                <Grid container spacing={24} justify="space-between" alignItems="center" style={{paddingTop: 8}}>
                    <Grid item>
                        {isEdit && (
                            <DeleteButton
                                href={`/persons/${values.id}`}
                                confirmMessage={i18n.get('persons.confirm_message')}
                                successMessage={i18n.get('persons.delete_success_message')}
                                handleSuccess={() => {history.go(-1)}}
                            />
                        )}
                    </Grid>
                    <Grid item>
                        <Button size="small"
                                variant="contained"
                                color="primary"
                                type="submit"
                        >
                            {isEdit ?
                                (<Icon fontSize="small">refresh</Icon>) :
                                (<Icon fontSize="small">save</Icon>)
                            } &nbsp;
                            {isEdit ? i18n.get('persons.update') : i18n.get('persons.save')}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        )
    }
}

export default CooperationsFormFields



// WEBPACK FOOTER //
// ./resources/assets/js/components/Cooperations/CooperationFormFields.js